import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { LoginForm } from './components/auth/LoginForm';
import { Dashboard } from './components/Dashboard';
import { UserProvider, useUser } from './contexts/UserContext';
import { UserManagement } from './pages/UserManagement';
import BeltManagement from './pages/BeltManagement';
import { ModuleManagement } from './pages/ModuleManagement';
import { SellerTrainingProgressReport } from './pages/SellerTrainingProgressReport';
import { Spinner } from './components/ui/Spinner';

// Protected Route component
function ProtectedRoute({ children, allowedRoles }: { children: React.ReactNode, allowedRoles?: string[] }) {
  const { isAuthenticated, hasRole, loading } = useUser();

  if (loading) {
    // You can use a spinner component or return null
    return <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh'}}><Spinner /></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !hasRole(allowedRoles)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/modules" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/modules/new" element={
            <ProtectedRoute allowedRoles={['corporate_admin']}>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/modules/:id" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="/modules/:id/edit" element={
            <ProtectedRoute allowedRoles={['corporate_admin']}>
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="/modules/:id/mapping" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="/users" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/belt-management" element={
            <ProtectedRoute allowedRoles={['corporate_admin']}>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/reports/module-execution" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/reports/seller-training-progress" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster />
      </Router>
    </UserProvider>
  );
}

export default App; 